import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { SubscriptionTierProvider } from './contexts/SubscriptionTierContext';
import { UpgradeModalProvider } from './contexts/UpgradeModalContext';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import PetRecordsPage from './pages/PetRecordsPage';
import RemindersPage from './pages/RemindersPage';

/**
 * Route structure:
 *  /login                    — public
 *  /register                 — public
 *  /                         — protected, Pet Dashboard
 *  /pets/:petId              — protected, Medical records timeline
 *  /pets/:petId/reminders    — protected, Reminders + local notifications
 *  *                         — redirect to /
 */
function App() {
  return (
    <AuthProvider>
      <SubscriptionTierProvider>
        <UpgradeModalProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />

              <Route element={<ProtectedRoute />}>
                <Route path="/" element={<DashboardPage />} />
                <Route path="/pets/:petId" element={<PetRecordsPage />} />
                <Route path="/pets/:petId/reminders" element={<RemindersPage />} />
              </Route>

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </UpgradeModalProvider>
      </SubscriptionTierProvider>
    </AuthProvider>
  );
}

export default App;
